import { Box } from '@mui/material';

import { Header } from 'src/components/Header';

import { GeneralBackground } from '../components/GeneralBackground';

export const PublicContractsLayout = ({ children }: { children: React.ReactNode }) => (
  <Box
    sx={(theme) => ({
      minHeight: '100vh',
      backgroundColor: theme.palette.background.chalk,
      position: 'relative',
      overflowX: 'clip',
      overflowY: 'visible',
    })}
  >
    <GeneralBackground />

    <Box sx={{ position: 'relative', zIndex: 1 }}>
      <Header />
      {children}
    </Box>
  </Box>
);
